export enum ECoUserPermission {
	CO_USERS_READ = 'co_users:read',
	CO_USERS_WRITE = 'co_users:write',
	CO_USERS_DELETE = 'co_users:delete',
}

export type EPermission = ECoUserPermission;
